import { GET_DASHBOARD } from './getDashboard';
import { GET_ADMIN_DASHBOARD_LIST } from './getAdminDashboardList';
import { ADMIN_GET_DASHBOARD_ACCOUNT_ACCESS } from './getDashboardAccountAccess';
import { GET_ADMIN_DASHBOARD_LIST_OPTIONS } from './getAdminDashboardListOptions';

import { ADMIN_CREATE_DASHBOARD } from './createDashboard';
import { ADMIN_UPDATE_DASHBOARD } from './updateDashboard';
import { ADMIN_DELETE_DASHBOARD } from './deleteDashboard';
import { ADMIN_UPDATE_DASHBOARD_ACCESS_BY_ACCOUNT } from './updateDashboardAccessByAccount';

export const adminExternalDashboardsApi = {
  getDashboard: GET_DASHBOARD,
  getAdminDashboardList: GET_ADMIN_DASHBOARD_LIST,
  getAdminDashboardListOptions: GET_ADMIN_DASHBOARD_LIST_OPTIONS,
  getDashboardAccountAccess: ADMIN_GET_DASHBOARD_ACCOUNT_ACCESS,

  createDashboard: ADMIN_CREATE_DASHBOARD,
  updateDashboard: ADMIN_UPDATE_DASHBOARD,
  deleteDashboard: ADMIN_DELETE_DASHBOARD,
  updateDashboardAccessByAccount: ADMIN_UPDATE_DASHBOARD_ACCESS_BY_ACCOUNT,
};

export * from './useExternalDashboards';
